import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header.js";
import "../../styles/SettlementsNew.css";
import { DownloadOutlined } from "@ant-design/icons";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import Call_Api from "../../Common/Handileapi/Call_api";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import { path } from "../../routes/Paths";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import * as XLSX from "xlsx";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Loaders from "../../components/ReusebleComponents/Loaders.jsx";
import StatusFilter from "../../Common/Filters/StatusFilter/statusfilter.jsx";
import DateFilter from "../../Common/Filters/DateFilter/datefilter.jsx";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import "../../CommonStyle/Tablestyling.css";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import {
  isFeatureActive,
  isFeatureServiceActive,
} from "../../Common/serviceActiveCheck/serviceActiveCheck.js";
import axios from "axios";
import { data } from "../../Common/Text/NormalText.js";

const SettlementsNew = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [t1Transactions, setT1Transactions] = useState("");
  const userDetails = useSelector((state) => state.user.user);
  const [filteredData, setFilteredData] = useState([]);
  const [allTransaction, setAllTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const [visiblePages, setVisiblePages] = useState([1, 2, 3]);
  const [activeFilter, setActiveFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userImage, setUserImage] = useState("");
  const features = useSelector((state) => state.activeFeatures.features);
  const apiUrl = process.env.REACT_APP_BACKEND_URL;

  const recordsPerPageOptions = [10, 25, 50, 100];
  useEffect(() => {
    getT1andT2();
    fetchSettlementstransactions();
    getUserImage();
  }, []);

  const getUserImage = async () => {
    const token = await GetWebAccessToken();
    try {
      const userImageRes = await Call_Api(
        path?.GET_USER_IMAGE(userDetails?.MerchantId),
        "GET",
        {},
        token,
      );
      console.log("User image response:", userImageRes);

      const base64Image = userImageRes?.response?.userimage;

      if (
        userImageRes?.success &&
        typeof base64Image === "string" &&
        base64Image.length > 100
      ) {
        setUserImage(base64Image);
      } else {
        setUserImage("");
      }
    } catch (err) {
      console.log("error in getting user image", err);
    }
  };

  // const handlePageClick = (page) => {
  //   if (page < 1 || page > totalPages) return;
  //   setCurrentPage(page);
  //   updateVisiblePages(page);
  // };

  const handlePageClick = (page) => {
    if (page === "..." || page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getT1andT2 = async () => {
    const token = await GetWebAccessToken();
    try {
      const t1andt2 = await Call_Api(
        path?.GET_T1_AND_T2_TRANSACTIONS,
        "GET",
        {},
        token,
      );
      console.log("t1andt2 =====>>>>", t1andt2);

      if (t1andt2?.success == true) {
        setT1Transactions(t1andt2?.response?.totalAmount);
      } else {
        setT1Transactions("");
      }
    } catch (error) {
      console.log("error in getting t1 and t2 ====>>>", error);
    }
  };

  const handleSettlementClick = () => {
    navigate("/SettlementDetails", {
      state: {
        unsettledBalance: t1Transactions,
        balance: userDetails?.walletBalance,
        serviceName: "Settlements",
      },
    });
  };

  const fetchSettlementstransactions = async () => {
    const token = await GetWebAccessToken();
    const headers = {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      setLoading(true);
      const response = await axios.get(
        `${apiUrl}/transactions/get/SelfTransferTransactions/service/subService?serviceName=Settlements&subService=Transfer&filterType=${
          selectedDate === "All" ? "" : selectedDate
        }&fromDate=${startDate}&toDate=${endDate}&payOutStatus=${
          selectedStatus === "All" ? "" : selectedStatus?.toUpperCase()
        }`,
        { headers },
      );
      console.log("response in settlement transfer====>>", response);
      if (response?.data?.success && response?.data?.data?.length > 0) {
        const paymentTransactions = response?.data?.data;
        console.log(
          "after if condition paymentTransactions length ===>",
          paymentTransactions.length,
        );
        setAllTransactions(paymentTransactions);
        setFilteredData(paymentTransactions);
        // setAllTransactions(paymentTransactions?.slice(0, batchSize));
      } else {
        setAllTransactions([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.log("error while fetching payment link details===>", error);
      setAllTransactions([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const sumAmount = useMemo(
    () =>
      filteredData.reduce(
        (acc, curr) =>
          curr?.payOutStatus?.toUpperCase() === "SUCCESS" ||
          curr?.payOutStatus?.toUpperCase() === "PROCESSING"
            ? acc + (curr.actualAmount || 0)
            : acc,
        0,
      ),
    [filteredData],
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  useEffect(() => {
    applyFilters();
    setCurrentPage(1);
  }, [searchTerm]);
  useEffect(() => {
    applyFilters();
  }, [selectedDate, selectedStatus, startDate, endDate]);

  const handleCopy = (copydata) => {
    navigator.clipboard.writeText(copydata || "");
    toast.success("copied to Clipboard!");
  };

  const applyFilters = () => {
    let filtered = allTransaction;
    const today = new Date();
    console.log("applyFilters ===>", filtered, selectedDate);

    if (selectedDate !== "All") {
      filtered = filtered.filter((t) => {
        const transactionDate = moment(t?.transactionDate, "DD/MM/YYYY");

        if (selectedDate === "Today") {
          return transactionDate.isSame(moment(), "day");
        } else if (selectedDate === "Last 7 Days") {
          return transactionDate.isBetween(
            moment().subtract(6, "days").startOf("day"),
            moment().endOf("day"),
            null,
            "[]",
          );
        } else if (selectedDate === "Last 30 Days") {
          return transactionDate.isBetween(
            moment().subtract(29, "days").startOf("day"),
            moment().endOf("day"),
            null,
            "[]",
          );
        } else if (selectedDate === "Custom") {
          const start = moment(startDate, "YYYY-MM-DD").startOf("day");
          const end = moment(endDate, "YYYY-MM-DD").endOf("day");
          return transactionDate.isBetween(start, end, null, "[]");
        }

        return true;
      });
    }

    if (selectedStatus !== "All") {
      filtered = filtered.filter((t) =>
        t?.payOutStatus?.toLowerCase()?.includes(selectedStatus?.toLowerCase()),
      );
    }
    if (searchTerm) {
      filtered = filtered.filter(
        (t) =>
          t?.transactionId?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
          t?.actualAmount?.toString().includes(searchTerm.toString()),
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
    // setShowDateFilter(false);
  };

  const handleExportToExcel = () => {
    if (filteredData.length === 0) {
      alert("No data to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((transaction, index) => ({
        SNO: index + 1,
        "Paid to": userDetails?.userName || "NA",
        "Transaction ID": transaction?.transactionId || "NA",
        Amount: transaction?.amount || 0,
        "Previous Balance": transaction?.walletPreviousBalance || "NA",
        "Updated Balance":
          transaction?.unSettledAmount ||
          Number(transaction?.walletPreviousBalance) -
            Number(transaction?.amount) ||
          "NA",
        Time: transaction?.transactionTime || "NA",
        Date: transaction?.transactionDate || "NA",
      })),
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
    XLSX.writeFile(workbook, "Transactions.xlsx");
  };

  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;

    const range = [];
    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    range.push(1);

    if (left > 2) range.push("...");

    for (let i = left; i <= right; i++) {
      range.push(i);
    }

    if (right < totalPages - 1) range.push("...");

    if (totalPages > 1) range.push(totalPages);

    return [...new Set(range)];
  };

  const ChangeCharacter = (str) => {
    const convertedString =
      str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    return convertedString;
  };

  if (transactionLoading) {
    return <Loaders />;
  }

  const handleFilterChange = (filters) => {
    console.log("Received from child:", filters);
    setSelectedDate(filters?.selectedDate);
    setStartDate(filters?.customStartDate || "");
    setEndDate(filters?.customEndDate || "");
    // applyFilters()
  };
  const hadleFilterPaymentStatus = (filters) => {
    console.log("Received from child:", filters);
    setSelectedStatus(filters);
    // applyFilters()
  };

  if (
    !isFeatureActive(features, "Settlements", "Transfer") ||
    userDetails?.walletStatus?.toLowerCase() != "active"
  ) {
    return <Navigate to="/" />;
  }

  if (loading) {
    return <Loaders />;
  }

  return (
    <>
      <div
        className={`settlement-container ${
          !isFeatureServiceActive(features, "Settlements", "Transfer")
            ? "disabled"
            : ""
        }`}
      >
        <div className="settlement-container-2">
          <Header title="Settlements" />
          {!isFeatureServiceActive(features, "Settlements", "Transfer") && (
            <div className="pay_active_service_s">
              <p className="error_service_down">{data?.seriveDown}</p>
            </div>
          )}
          <div className="All-balance-container">
            <div className="SN-scale">
              <div className="avatar-settlementnew">
                <img
                  className="avatar-img"
                  src={
                    userDetails?.userimage !== "true" &&
                    typeof userDetails?.userimage === "string"
                      ? `data:image/png;base64,${userDetails.userimage}`
                      : userImage
                        ? `data:image/png;base64,${userImage}`
                        : ImagesPath?.Settlement?.NewAvatar
                  }
                />
                <div className="name-account-settlementnew">
                  <p className="name-settlementnew">
                    {userDetails?.userName || "N/A"}
                  </p>
                  <div className="add_ac">
                    <p className="account-settlementnew">
                      {userDetails?.bankDetails?.length
                        ? (() => {
                            const primaryAccount = userDetails.bankDetails.find(
                              (acc) =>
                                acc.accountType?.toLowerCase() === "primary",
                            );
                            return primaryAccount
                              ? `A/C ${primaryAccount.accountNo} (${primaryAccount?.accountIFSCCode})`
                              : "N/A";
                          })()
                        : "N/A"}
                    </p>
                    <p
                      className="add_button"
                      onClick={() => navigate("/settlementBank")}
                    >
                      <img
                        src={ImagesPath?.edit}
                        alt="No Image"
                        height={24}
                        width={24}
                      />
                    </p>
                  </div>
                </div>
              </div>

              <div className="balance-cards-container">
                <div className="balance-card">
                  <div className="balance-card-container">
                    <div className="balance-icon-container">
                      <img src={ImagesPath?.Settlement?.Revenue} />
                      <span className="balance-label-sn">{data?.Balance}</span>
                    </div>
                    <hr className="gradient-line-settlement" />
                    <div className="balance-details">
                      <div className="balance-amount-container">
                        <h2 className="balance-amount">
                          ₹ {Number(userDetails?.walletBalance).toFixed(2)}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="balance-card">
                  <div className="balance-card-container">
                    <div className="balance-icon-container">
                      <img src={ImagesPath?.Settlement?.Revenue} />
                      <span className="balance-label-sn">
                        {data?.Unsettled}
                      </span>
                    </div>
                    <hr className="gradient-line-settlement" />
                    <div className="balance-details">
                      <div className="balance-amount-container">
                        <h2 className="balance-amount">
                          ₹ {Number(t1Transactions).toFixed(2)}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="settlement-status-card">
                  <div className="wave-background"></div>
                  <div className="status-content">
                    <div className="settlement-header">
                      <h2 style={{ color: "white" }}>
                        {data?.settlement}
                        {userDetails?.allowWalletSettlements?.includes(
                          "Settlements",
                        ) && userDetails?.walletStatus == "Active"
                          ? "Enabled"
                          : "Not Enabled"}
                      </h2>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={
                            userDetails?.allowWalletSettlements?.includes(
                              "Settlements",
                            ) && userDetails?.walletStatus == "Active"
                              ? true
                              : false
                          }
                        />
                        <span className="toggle-slider"></span>
                      </label>
                    </div>
                    <div className="payment-info">
                      <button
                        className="settlementnew-button"
                        onClick={handleSettlementClick}
                        disabled={
                          !userDetails?.allowWalletSettlements?.includes(
                            "Settlements",
                          ) || userDetails?.walletStatus !== "Active"
                        }
                      >
                        {data?.settlement}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="transactions-section">
                <div className="transactions-header">
                  <div className="search-download">
                    <div className="search-container">
                      <SearchIcon
                        style={{ color: "var(--thirdshade-orange)" }}
                        className="search-icon"
                      />
                      <input
                        type="text"
                        placeholder="Search here"
                        className="search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <button
                      className="download-button"
                      onClick={handleExportToExcel}
                    >
                      <span>
                        <DownloadOutlined style={{ fontSize: "1.2rem" }} />
                      </span>{" "}
                      {data?.down}
                    </button>
                  </div>

                  <div className="sn-filters">
                    <DateFilter
                      onFilterChange={handleFilterChange}
                      activeFilter={activeFilter}
                      setActiveFilter={setActiveFilter}
                      type=""
                      selectedDate={selectedDate}
                    />
                    <StatusFilter
                      onFilterChange={hadleFilterPaymentStatus}
                      activeFilter={activeFilter}
                      setActiveFilter={setActiveFilter}
                      type="PaymentStatus"
                    />
                  </div>
                </div>

                <div className="transactions-table">
                  <div className="sn-table-header">
                    <span>{selectedDate}</span>
                    <span className="amount-header">
                      {" "}
                      ₹ {sumAmount}{" "}
                      {`(${filteredData?.length} out of ${allTransaction?.length})`}
                    </span>
                  </div>

                  <table className="common-table-v">
                    <thead className="SN-table-header">
                      <th
                        style={{ textAlign: "left" }}
                        className="name-SN-each-th"
                      >
                        {data?.Paid}
                      </th>
                      <th className="SN-each-th">{data?.tID}</th>
                      <th className="SN-each-th">{data?.uNum}</th>
                      <th className="SN-each-th">{data?.amount}</th>
                      <th className="SN-each-th">{data?.Date}</th>
                      <th className="SN-each-th">{data?.status}</th>
                    </thead>
                    <tbody>
                      {transactionLoading ? (
                        <CircularProgress color="secondary" />
                      ) : filteredData?.length > 0 ? (
                        paginatedData?.map((transaction) => (
                          <tr className="SN-table-tr" key={transaction?.id}>
                            <td className="each-td">
                              <div className="user-info-settlement">
                                <img
                                  className="user-avatar"
                                  src={ImagesPath?.Settlement?.bank}
                                  alt="bank"
                                />
                                <div className="user-details">
                                  {/* <span>{transaction?.beneficiaryName}</span> */}
                                  <span>
                                    {transaction?.beneficiaryName &&
                                      transaction.beneficiaryName
                                        .toLowerCase()
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word?.slice(1),
                                        )
                                        .join(" ")}
                                  </span>
                                  <span className="user-id">
                                    {transaction?.beneficiaryAccountNumber}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="each-td">
                              <span className="transaction-id">
                                {transaction?.transactionId?.slice(0, 10)}...
                                <span className="tooltip">
                                  {transaction?.transactionId}
                                </span>
                              </span>
                              &nbsp;&nbsp;
                              <span style={{ cursor: "pointer" }}>
                                <img
                                  src={ImagesPath?.Settlement?.CopyIcon}
                                  alt="Copy"
                                  onClick={() =>
                                    handleCopy(transaction?.transactionId)
                                  }
                                />
                              </span>
                            </td>

                            <td className="each-td">
                              {transaction?.payOutUTRNo || "N/A"}&nbsp;&nbsp;
                              {transaction?.payOutUTRNo && (
                                <img
                                  style={{ cursor: "pointer" }}
                                  src={ImagesPath?.Settlement?.CopyIcon}
                                  alt="Copy"
                                  onClick={() =>
                                    handleCopy(transaction?.payOutUTRNo)
                                  }
                                />
                              )}
                            </td>
                            {/* Amount Field with Dynamic Color */}
                            <td
                              className={`amount-cell ${
                                transaction?.payOutStatus?.toLowerCase() ===
                                "success"
                                  ? "amount-success"
                                  : transaction?.payOutStatus?.toLowerCase() ===
                                      "failed"
                                    ? "amount-failed"
                                    : "amount-processing"
                              }`}
                            >
                              ₹ {transaction?.actualAmount}
                            </td>
                            <td className="each-td">
                              {transaction?.transactionDate}
                              {transaction?.transactionTime}
                            </td>
                            <td className="status-msgs-settlement">
                              <span
                                className={`status-badge ${transaction?.payOutStatus?.toLowerCase()}`}
                              >
                                {transaction?.payOutStatus
                                  ? ChangeCharacter(transaction?.payOutStatus)
                                  : ""}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <td
                          colSpan={6}
                          style={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          {data?.noData}
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {totalPages > 0 && (
              <div className="d-flex justify-content-between px-4 align-items-center">
                <div>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(e.target.value);
                      setCurrentPage(1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="itemsperpage"
                  >
                    {recordsPerPageOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                <div className="pagination">
                  <ArrowBackIosIcon
                    onClick={() => handlePageClick(currentPage - 1)}
                    style={{
                      color: "#B4B4B4",
                      fontSize: "1.5rem",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    }}
                  />

                  {getPageNumbers().map((page, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                      className={currentPage === page ? "active" : ""}
                      style={{
                        background:
                          currentPage === page ? "#CADFF2" : "#B4B4B4",
                        width: "2rem",
                        borderRadius: "0.5rem",
                        color: "#fff",
                        border: "none",
                        cursor: page === "..." ? "default" : "pointer",
                        padding: "0.3rem",
                        margin: "0 4px",
                      }}
                    >
                      {page}
                    </button>
                  ))}

                  <ArrowForwardIosIcon
                    onClick={() => handlePageClick(currentPage + 1)}
                    style={{
                      color: "#B4B4B4",
                      fontSize: "1.5rem",
                      cursor:
                        currentPage === totalPages ? "not-allowed" : "pointer",
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SettlementsNew;




// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { Navigate, useNavigate } from "react-router-dom";
// import Header from "../../components/Header/Header.js";
// import "../../styles/SettlementsNew.css";
// import { DownloadOutlined } from "@ant-design/icons";
// import SearchIcon from "@mui/icons-material/Search";
// import { useSelector } from "react-redux";
// import Call_Api from "../../Common/Handileapi/Call_api";
// import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
// import { path } from "../../routes/Paths";
// import { toast } from "react-toastify";
// import { CircularProgress } from "@mui/material";
// import * as XLSX from "xlsx";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import Loaders from "../../components/ReusebleComponents/Loaders.jsx";
// import StatusFilter from "../../Common/Filters/StatusFilter/statusfilter.jsx";
// import DateFilter from "../../Common/Filters/DateFilter/datefilter.jsx";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import moment from "moment";
// import "../../CommonStyle/Tablestyling.css";
// import { ImagesPath } from "../../Common/imagespath/imagespath";
// import {
//   isFeatureActive,
//   isFeatureServiceActive,
// } from "../../Common/serviceActiveCheck/serviceActiveCheck.js";
// import axios from "axios";
// import { data } from "../../Common/Text/NormalText.js";

// const SettlementsNew = () => {
//   const navigate = useNavigate();
//   const [selectedDate, setSelectedDate] = useState("All");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("All");
//   const [t1Transactions, setT1Transactions] = useState("");
//   const userDetails = useSelector((state) => state.user.user);
//   const [filteredData, setFilteredData] = useState([]);
//   const [allTransaction, setAllTransactions] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [transactionLoading, setTransactionLoading] = useState(false);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   // const [visiblePages, setVisiblePages] = useState([1, 2, 3]);
//   const [activeFilter, setActiveFilter] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [userImage, setUserImage] = useState("");
//   const features = useSelector((state) => state.activeFeatures.features);
//   const apiUrl = process.env.REACT_APP_BACKEND_URL;

//   const recordsPerPageOptions = [10, 25, 50, 100];
//   useEffect(() => {
//     getT1andT2();
//     fetchSettlementstransactions();
//     getUserImage();
//   }, []);

//   const getUserImage = async () => {
//     const token = await GetWebAccessToken();
//     try {
//       const userImageRes = await Call_Api(
//         path?.GET_USER_IMAGE(userDetails?.MerchantId),
//         "GET",
//         {},
//         token
//       );
//       console.log("User image response:", userImageRes);

//       const base64Image = userImageRes?.response?.userimage;

//       if (
//         userImageRes?.success &&
//         typeof base64Image === "string" &&
//         base64Image.length > 100
//       ) {
//         setUserImage(base64Image);
//       } else {
//         setUserImage("");
//       }
//     } catch (err) {
//       console.log("error in getting user image", err);
//     }
//   };

//   // const handlePageClick = (page) => {
//   //   if (page < 1 || page > totalPages) return;
//   //   setCurrentPage(page);
//   //   updateVisiblePages(page);
//   // };

//   const handlePageClick = (page) => {
//     if (page === "..." || page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const getT1andT2 = async () => {
//     const token = await GetWebAccessToken();
//     try {
//       const t1andt2 = await Call_Api(
//         path?.GET_T1_AND_T2_TRANSACTIONS,
//         "GET",
//         {},
//         token
//       );
//       console.log("t1andt2 =====>>>>", t1andt2);

//       if (t1andt2?.success == true) {
//         setT1Transactions(t1andt2?.response?.totalAmount);
//       } else {
//         setT1Transactions("");
//       }
//     } catch (error) {
//       console.log("error in getting t1 and t2 ====>>>", error);
//     }
//   };

//   const handleSettlementClick = () => {
//     navigate("/SettlementDetails", {
//       state: {
//         unsettledBalance: t1Transactions,
//         balance: userDetails?.walletBalance,
//         serviceName: "Settlements",
//       },
//     });
//   };

//   const fetchSettlementstransactions = async () => {
//     const token = await GetWebAccessToken();
//     const headers = {
//       "Cache-Control": "no-cache",
//       Pragma: "no-cache",
//       Authorization: `Bearer ${token}`,
//     };
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${apiUrl}/transactions/get/SelfTransferTransactions/service/subService?serviceName=Settlements&subService=Transfer&filterType=${
//           selectedDate === "All" ? "" : selectedDate
//         }&fromDate=${startDate}&toDate=${endDate}&payOutStatus=${
//           selectedStatus === "All" ? "" : selectedStatus?.toUpperCase()
//         }`,
//         { headers }
//       );
//       if (response?.data?.message === "valid") {
//         const paymentTransactions = response?.data?.data;
//         console.log(
//           "after if condition paymentTransactions length ===>",
//           paymentTransactions.length
//         );
//         setAllTransactions(paymentTransactions);
//         setFilteredData(paymentTransactions);
//         // setAllTransactions(paymentTransactions?.slice(0, batchSize));
//       } else {
//         setAllTransactions([]);
//         setFilteredData([]);
//       }
//     } catch (error) {
//       console.log("error while fetching payment link details===>", error);
//       setAllTransactions([]);
//       setFilteredData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sumAmount = useMemo(
//     () =>
//       filteredData.reduce(
//         (acc, curr) =>
//           curr?.payOutStatus?.toUpperCase() === "SUCCESS" ||
//           curr?.payOutStatus?.toUpperCase() === "PROCESSING"
//             ? acc + (curr.actualAmount || 0)
//             : acc,
//         0
//       ),
//     [filteredData]
//   );
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   useEffect(() => {
//     applyFilters();
//     setCurrentPage(1);
//   }, [searchTerm]);
//   useEffect(() => {
//     applyFilters();
//   }, [selectedDate, selectedStatus, startDate, endDate]);

//   const handleCopy = (copydata) => {
//     navigator.clipboard.writeText(copydata || "");
//     toast.success("copied to Clipboard!");
//   };

//   const applyFilters = () => {
//     let filtered = allTransaction;
//     const today = new Date();
//     console.log("applyFilters ===>", filtered, selectedDate);

//     if (selectedDate !== "All") {
//       filtered = filtered.filter((t) => {
//         const transactionDate = moment(t?.transactionDate, "DD/MM/YYYY");

//         if (selectedDate === "Today") {
//           return transactionDate.isSame(moment(), "day");
//         } else if (selectedDate === "Last 7 Days") {
//           return transactionDate.isBetween(
//             moment().subtract(6, "days").startOf("day"),
//             moment().endOf("day"),
//             null,
//             "[]"
//           );
//         } else if (selectedDate === "Last 30 Days") {
//           return transactionDate.isBetween(
//             moment().subtract(29, "days").startOf("day"),
//             moment().endOf("day"),
//             null,
//             "[]"
//           );
//         } else if (selectedDate === "Custom") {
//           const start = moment(startDate, "YYYY-MM-DD").startOf("day");
//           const end = moment(endDate, "YYYY-MM-DD").endOf("day");
//           return transactionDate.isBetween(start, end, null, "[]");
//         }

//         return true;
//       });
//     }

//     if (selectedStatus !== "All") {
//       filtered = filtered.filter((t) =>
//         t?.payOutStatus?.toLowerCase()?.includes(selectedStatus?.toLowerCase())
//       );
//     }
//     if (searchTerm) {
//       filtered = filtered.filter(
//         (t) =>
//           t?.transactionId?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
//           t?.actualAmount?.toString().includes(searchTerm.toString())
//       );
//     }

//     setFilteredData(filtered);
//     setCurrentPage(1);
//     // setShowDateFilter(false);
//   };

//   const handleExportToExcel = () => {
//     if (filteredData.length === 0) {
//       alert("No data to export.");
//       return;
//     }

//     const worksheet = XLSX.utils.json_to_sheet(
//       filteredData.map((transaction, index) => ({
//         SNO: index + 1,
//         "Paid to": userDetails?.userName || "NA",
//         "Transaction ID": transaction?.transactionId || "NA",
//         Amount: transaction?.amount || 0,
//         "Previous Balance": transaction?.walletPreviousBalance || "NA",
//         "Updated Balance":
//           transaction?.unSettledAmount ||
//           Number(transaction?.walletPreviousBalance) -
//             Number(transaction?.amount) ||
//           "NA",
//         Time: transaction?.transactionTime || "NA",
//         Date: transaction?.transactionDate || "NA",
//       }))
//     );

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
//     XLSX.writeFile(workbook, "Transactions.xlsx");
//   };

//   const getPageNumbers = () => {
//     const pages = [];

//     for (let i = 1; i <= Math.min(3, totalPages); i++) {
//       pages.push(i);
//     }

//     if (totalPages > 3) {
//       pages.push("...");
//       pages.push(totalPages);
//     }

//     return pages;
//   };

//   const ChangeCharacter = (str) => {
//     const convertedString =
//       str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
//     return convertedString;
//   };

//   if (transactionLoading) {
//     return <Loaders />;
//   }

//   const handleFilterChange = (filters) => {
//     console.log("Received from child:", filters);
//     setSelectedDate(filters?.selectedDate);
//     setStartDate(filters?.customStartDate || "");
//     setEndDate(filters?.customEndDate || "");
//     // applyFilters()
//   };
//   const hadleFilterPaymentStatus = (filters) => {
//     console.log("Received from child:", filters);
//     setSelectedStatus(filters);
//     // applyFilters()
//   };

//   if (
//     !isFeatureActive(features, "Settlements", "Transfer") ||
//     userDetails?.walletStatus?.toLowerCase() != "active"
//   ) {
//     return <Navigate to="/" />;
//   }

//   if (loading) {
//     return <Loaders />;
//   }

//   return (
//     <>
//       <div
//         className={`settlement-container ${
//           !isFeatureServiceActive(features, "Settlements", "Transfer")
//             ? "disabled"
//             : ""
//         }`}
//       >
//         <div className="settlement-container-2">
//           <Header title="Settlements" />
//           {!isFeatureServiceActive(features, "Settlements", "Transfer") && (
//             <div className="pay_active_service_s">
//               <p className="error_service_down">{data?.seriveDown}</p>
//             </div>
//           )}
//           <div className="All-balance-container">
//             <div className="SN-scale">
//               <div className="avatar-settlementnew">
//                 <img
//                   className="avatar-img"
//                   src={
//                     userDetails?.userimage !== "true" &&
//                     typeof userDetails?.userimage === "string"
//                       ? `data:image/png;base64,${userDetails.userimage}`
//                       : userImage
//                       ? `data:image/png;base64,${userImage}`
//                       : ImagesPath?.Settlement?.NewAvatar
//                   }
//                 />
//                 <div className="name-account-settlementnew">
//                   <p className="name-settlementnew">
//                     {userDetails?.userName || "N/A"}
//                   </p>
//                   <div className="add_ac">
//                     <p className="account-settlementnew">
//                       {userDetails?.bankDetails?.length
//                         ? (() => {
//                             const primaryAccount = userDetails.bankDetails.find(
//                               (acc) =>
//                                 acc.accountType?.toLowerCase() === "primary"
//                             );
//                             return primaryAccount
//                               ? `A/C ${primaryAccount.accountNo} (${primaryAccount?.accountIFSCCode})`
//                               : "N/A";
//                           })()
//                         : "N/A"}
//                     </p>
//                     <p
//                       className="add_button"
//                       onClick={() => navigate("/settlementBank")}
//                     >
//                       <img
//                         src={ImagesPath?.edit}
//                         alt="No Image"
//                         height={24}
//                         width={24}
//                       />
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="balance-cards-container">
//                 <div className="balance-card">
//                   <div className="balance-card-container">
//                     <div className="balance-icon-container">
//                       <img src={ImagesPath?.Settlement?.Revenue} />
//                       <span className="balance-label-sn">{data?.Balance}</span>
//                     </div>
//                     <hr className="gradient-line-settlement" />
//                     <div className="balance-details">
//                       <div className="balance-amount-container">
//                         <h2 className="balance-amount">
//                           ₹ {Number(userDetails?.walletBalance).toFixed(2)}
//                         </h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="balance-card">
//                   <div className="balance-card-container">
//                     <div className="balance-icon-container">
//                       <img src={ImagesPath?.Settlement?.Revenue} />
//                       <span className="balance-label-sn">
//                         {data?.Unsettled}
//                       </span>
//                     </div>
//                     <hr className="gradient-line-settlement" />
//                     <div className="balance-details">
//                       <div className="balance-amount-container">
//                         <h2 className="balance-amount">
//                           ₹ {Number(t1Transactions).toFixed(2)}
//                         </h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="settlement-status-card">
//                   <div className="wave-background"></div>
//                   <div className="status-content">
//                     <div className="settlement-header">
//                       <h2 style={{ color: "white" }}>
//                         {data?.settlement}
//                         {userDetails?.allowWalletSettlements?.includes(
//                           "Settlements"
//                         ) && userDetails?.walletStatus == "Active"
//                           ? "Enabled"
//                           : "Not Enabled"}
//                       </h2>
//                       <label className="toggle-switch">
//                         <input
//                           type="checkbox"
//                           checked={
//                             userDetails?.allowWalletSettlements?.includes(
//                               "Settlements"
//                             ) && userDetails?.walletStatus == "Active"
//                               ? true
//                               : false
//                           }
//                         />
//                         <span className="toggle-slider"></span>
//                       </label>
//                     </div>
//                     <div className="payment-info">
//                       <button
//                         className="settlementnew-button"
//                         onClick={handleSettlementClick}
//                         disabled={
//                           !userDetails?.allowWalletSettlements?.includes(
//                             "Settlements"
//                           ) || userDetails?.walletStatus !== "Active"
//                         }
//                       >
//                         {data?.settlement}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="transactions-section">
//                 <div className="transactions-header">
//                   <div className="search-download">
//                     <div className="search-container">
//                       <SearchIcon
//                         style={{ color: "var(--thirdshade-orange)" }}
//                         className="search-icon"
//                       />
//                       <input
//                         type="text"
//                         placeholder="Search here"
//                         className="search"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                       />
//                     </div>
//                     <button
//                       className="download-button"
//                       onClick={handleExportToExcel}
//                     >
//                       <span>
//                         <DownloadOutlined style={{ fontSize: "1.2rem" }} />
//                       </span>{" "}
//                       {data?.down}
//                     </button>
//                   </div>

//                   <div className="sn-filters">
//                     <DateFilter
//                       onFilterChange={handleFilterChange}
//                       activeFilter={activeFilter}
//                       setActiveFilter={setActiveFilter}
//                     />

//                     <StatusFilter
//                       onFilterChange={hadleFilterPaymentStatus}
//                       activeFilter={activeFilter}
//                       setActiveFilter={setActiveFilter}
//                       type="PaymentStatus"
//                     />
//                   </div>
//                 </div>

//                 <div className="transactions-table">
//                   <div className="sn-table-header">
//                     <span>{selectedDate}</span>
//                     <span className="amount-header"> ₹ {sumAmount}</span>
//                   </div>

//                   <table className="common-table-v">
//                     <thead className="SN-table-header">
//                       <th
//                         style={{ textAlign: "left" }}
//                         className="name-SN-each-th"
//                       >
//                         {data?.Paid}
//                       </th>
//                       <th className="SN-each-th">{data?.tID}</th>
//                       <th className="SN-each-th">{data?.uNum}</th>
//                       <th className="SN-each-th">{data?.amount}</th>
//                       <th className="SN-each-th">{data?.Date}</th>
//                       <th className="SN-each-th">{data?.status}</th>
//                     </thead>
//                     <tbody>
//                       {transactionLoading ? (
//                         <CircularProgress color="secondary" />
//                       ) : filteredData?.length > 0 ? (
//                         paginatedData?.map((transaction) => (
//                           <tr className="SN-table-tr" key={transaction?.id}>
//                             <td className="each-td">
//                               <div className="user-info-settlement">
//                                 <img
//                                   className="user-avatar"
//                                   src={ImagesPath?.Settlement?.bank}
//                                   alt="bank"
//                                 />
//                                 <div className="user-details">
//                                   {/* <span>{transaction?.beneficiaryName}</span> */}
//                                   <span>
//                                     {transaction?.beneficiaryName &&
//                                       transaction.beneficiaryName
//                                         .toLowerCase()
//                                         .split(" ")
//                                         .map(
//                                           (word) =>
//                                             word.charAt(0).toUpperCase() +
//                                             word?.slice(1)
//                                         )
//                                         .join(" ")}
//                                   </span>
//                                   <span className="user-id">
//                                     {transaction?.beneficiaryAccountNumber}
//                                   </span>
//                                 </div>
//                               </div>
//                             </td>
//                             <td className="each-td">
//                               <span className="transaction-id">
//                                 {transaction?.transactionId?.slice(0, 10)}...
//                                 <span className="tooltip">
//                                   {transaction?.transactionId}
//                                 </span>
//                               </span>
//                               &nbsp;&nbsp;
//                               <span style={{ cursor: "pointer" }}>
//                                 <img
//                                   src={ImagesPath?.Settlement?.CopyIcon}
//                                   alt="Copy"
//                                   onClick={() =>
//                                     handleCopy(transaction?.transactionId)
//                                   }
//                                 />
//                               </span>
//                             </td>

//                             <td className="each-td">
//                               {transaction?.payOutUTRNo || "N/A"}&nbsp;&nbsp;
//                               {transaction?.payOutUTRNo && (
//                                 <img
//                                   style={{ cursor: "pointer" }}
//                                   src={ImagesPath?.Settlement?.CopyIcon}
//                                   alt="Copy"
//                                   onClick={() =>
//                                     handleCopy(transaction?.payOutUTRNo)
//                                   }
//                                 />
//                               )}
//                             </td>
//                             {/* Amount Field with Dynamic Color */}
//                             <td
//                               className={`amount-cell ${
//                                 transaction?.payOutStatus?.toLowerCase() ===
//                                 "success"
//                                   ? "amount-success"
//                                   : transaction?.payOutStatus?.toLowerCase() ===
//                                     "failed"
//                                   ? "amount-failed"
//                                   : "amount-processing"
//                               }`}
//                             >
//                               ₹ {transaction?.actualAmount}
//                             </td>
//                             <td className="each-td">
//                               {transaction?.transactionDate}
//                               {transaction?.transactionTime}
//                             </td>
//                             <td className="status-msgs-settlement">
//                               <span
//                                 className={`status-badge ${transaction?.payOutStatus?.toLowerCase()}`}
//                               >
//                                 {transaction?.payOutStatus
//                                   ? ChangeCharacter(transaction?.payOutStatus)
//                                   : ""}
//                               </span>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <td
//                           colSpan={6}
//                           style={{ textAlign: "center", fontWeight: "bold" }}
//                         >
//                           {data?.noData}
//                         </td>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             {totalPages > 0 && (
//               <div className="d-flex justify-content-between px-4">
//                 <div>
//                   <Select
//                     value={itemsPerPage}
//                     onChange={(e) => {
//                       setItemsPerPage(e.target.value);
//                       setCurrentPage(1);
//                       window.scrollTo({ top: 0, behavior: "smooth" });
//                     }}
//                     className="itemsperpage"
//                   >
//                     {recordsPerPageOptions.map((option) => (
//                       <MenuItem key={option} value={option}>
//                         {option}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </div>
//                 {/* <div className="pagination">
//                   <ArrowBackIosIcon
//                     style={{ color: "#B4B4B4", fontSize: "1.5rem" }}
//                     onClick={() => handlePageClick(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />

//                   {visiblePages.map((page) => (
//                     <button
//                       key={page}
//                       className={currentPage === page ? "active" : ""}
//                       style={{
//                         background:
//                           currentPage === page ? "#CADFF2" : "#B4B4B4", // Green for active, Grey for inactive
//                         width: "2rem",
//                         borderRadius: "0.5rem",
//                         color: "var(--white)",
//                         border: "none",
//                         cursor: "pointer",
//                         padding: "0.3rem",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                       onClick={() => handlePageClick(page)}
//                       disabled={page === currentPage}
//                     >
//                       {page}
//                     </button>
//                   ))}

//                   <ArrowForwardIosIcon
//                     style={{ color: "#B4B4B4", fontSize: "1.5rem" }}
//                     onClick={() => handlePageClick(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </div> */}

//                 <div className="pagination">
//                   <ArrowBackIosIcon
//                     onClick={() => handlePageClick(currentPage - 1)}
//                     style={{
//                       color: "#B4B4B4",
//                       fontSize: "1.5rem",
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   />

//                   {getPageNumbers().map((page, index) => (
//                     <button
//                       key={index}
//                       onClick={() => handlePageClick(page)}
//                       disabled={page === "..."}
//                       className={currentPage === page ? "active" : ""}
//                       style={{
//                         background:
//                           currentPage === page ? "#CADFF2" : "#B4B4B4",
//                         width: "2rem",
//                         borderRadius: "0.5rem",
//                         color: "#fff",
//                         border: "none",
//                         cursor: page === "..." ? "default" : "pointer",
//                         padding: "0.3rem",
//                         margin: "0 4px",
//                       }}
//                     >
//                       {page}
//                     </button>
//                   ))}

//                   <ArrowForwardIosIcon
//                     onClick={() => handlePageClick(currentPage + 1)}
//                     style={{
//                       color: "#B4B4B4",
//                       fontSize: "1.5rem",
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SettlementsNew;
